import { getCornKernels, isCorn } from '@eigtech/shared-corn';
import { serviceName as documentsServiceName, documentResourceType, } from '@eigtech/documents-types';
export const ensureDocumentCorn = (id) => isDocumentCorn(id) ? id : makeDocumentCorn(id);
export const makeDocumentCorn = (resourceId) => `corn:documents:document:${resourceId}`;
export const isDocumentCorn = (entityId) => {
    if (!isCorn(entityId))
        return false;
    const { serviceName, resourceType } = getCornKernels(entityId);
    return serviceName === documentsServiceName && resourceType === documentResourceType;
};
